module.exports = __webpack_public_path__ + "UX15.png?d41abeb7ba9496f583b5e8e7da7ae8da";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX15.png
// module id = 64
// module chunks = 0